import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var NonCompliance =
/*#__PURE__*/
function () {
  function NonCompliance() {
    _classCallCheck(this, NonCompliance);
  }

  _createClass(NonCompliance, [{
    key: "GetActiveNonCompliance",
    value: function () {
      var _GetActiveNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/NonCompliance/GetActive/".concat(projectId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetActiveNonCompliance(_x) {
        return _GetActiveNonCompliance.apply(this, arguments);
      }

      return GetActiveNonCompliance;
    }()
  }, {
    key: "DeleteIssue",
    value: function () {
      var _DeleteIssue = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.delete("/api/NonCompliance/".concat(id)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function DeleteIssue(_x2) {
        return _DeleteIssue.apply(this, arguments);
      }

      return DeleteIssue;
    }()
  }, {
    key: "CloseIssue",
    value: function () {
      var _CloseIssue = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.put("/api/NonCompliance/CloseIssue/".concat(id)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function CloseIssue(_x3) {
        return _CloseIssue.apply(this, arguments);
      }

      return CloseIssue;
    }()
  }, {
    key: "UpdateNonCompliance",
    value: function () {
      var _UpdateNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(nonCompliance) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.put("/api/NonCompliance/UpdateNonCompliance", nonCompliance));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function UpdateNonCompliance(_x4) {
        return _UpdateNonCompliance.apply(this, arguments);
      }

      return UpdateNonCompliance;
    }()
  }, {
    key: "Query",
    value: function () {
      var _Query = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(open, managementCompanyId, projectId, typeID, from, to, propertyStatus, isAdmin) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/NonCompliance/Query", {
                  params: {
                    open: open,
                    managementCompanyId: managementCompanyId,
                    projectId: projectId,
                    typeID: typeID,
                    from: from,
                    to: to,
                    propertyStatus: propertyStatus,
                    isAdmin: isAdmin
                  }
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function Query(_x5, _x6, _x7, _x8, _x9, _x10, _x11, _x12) {
        return _Query.apply(this, arguments);
      }

      return Query;
    }()
  }, {
    key: "CreateIssue",
    value: function () {
      var _CreateIssue = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(issue) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.post("/api/NonCompliance", issue));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function CreateIssue(_x13) {
        return _CreateIssue.apply(this, arguments);
      }

      return CreateIssue;
    }()
  }, {
    key: "GetByProjectId",
    value: function () {
      var _GetByProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(projectId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/NonCompliance/GetByProjectId/".concat(projectId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function GetByProjectId(_x14) {
        return _GetByProjectId.apply(this, arguments);
      }

      return GetByProjectId;
    }()
  }, {
    key: "GetManagementCompanyComplianceRecords",
    value: function () {
      var _GetManagementCompanyComplianceRecords = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/NonCompliance/GetManagementCompanyComplianceRecords/".concat(managementCompanyId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function GetManagementCompanyComplianceRecords(_x15) {
        return _GetManagementCompanyComplianceRecords.apply(this, arguments);
      }

      return GetManagementCompanyComplianceRecords;
    }()
  }, {
    key: "GetTypes",
    value: function () {
      var _GetTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/NonCompliance/GetTypes"));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function GetTypes() {
        return _GetTypes.apply(this, arguments);
      }

      return GetTypes;
    }()
  }, {
    key: "IsNonCompliant",
    value: function () {
      var _IsNonCompliant = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(projectId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.get("/api/NonCompliance/ProjectNonCompliant/".concat(projectId), {
                  doNotShowLoading: true
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function IsNonCompliant(_x16) {
        return _IsNonCompliant.apply(this, arguments);
      }

      return IsNonCompliant;
    }()
  }, {
    key: "GetFutureNonCompliance",
    value: function () {
      var _GetFutureNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(days, moduleIds) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.post("/api/NonCompliance/GetFutureNonCompliance/".concat(days), moduleIds));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function GetFutureNonCompliance(_x17, _x18) {
        return _GetFutureNonCompliance.apply(this, arguments);
      }

      return GetFutureNonCompliance;
    }()
  }]);

  return NonCompliance;
}();

export default new NonCompliance();